import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import RadioGroup from '@atoms/RadioGroup';
import Input from '@atoms/Input';
import Select from '@atoms/Select';
import Button from '@atoms/Button';

import { useForm, Form } from './useForm';
import * as employeeService from './employeeService';

const ContentItems = [
  { id: 'Buy', title: 'BUY' },
  { id: 'Sell', title: 'SELL' }
];

const initialFValues = {
  id: 0,
  name: 0,
  opinion: '',
  contents: ''
};

export default function ModalForm(props) {
  const { addOrEdit, recordForEdit, setOpenPopup } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ('opinion' in fieldValues)
      temp.fullName = fieldValues.opinion ? '' : 'This field is required.';
    if ('name' in fieldValues)
      temp.fullName = fieldValues.name ? '' : 'This field is required.';
    if ('contents' in fieldValues)
      temp.fullName = fieldValues.contents ? '' : 'This field is required.';
    // if ('email' in fieldValues)
    //     temp.email = (/$^|.+@.+..+/).test(fieldValues.email) ? "" : "Email is not valid."
    // if ('mobile' in fieldValues)
    //     temp.mobile = fieldValues.mobile.length > 9 ? "" : "Minimum 10 numbers required."
    // if ('departmentId' in fieldValues)
    //     temp.departmentId = fieldValues.departmentId.length != 0 ? "" : "This field is required."
    setErrors({
      ...temp
    });

    if (fieldValues === values) return Object.values(temp).every(x => x === '');
  };

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm,
    InsertForm
  } = useForm(initialFValues, true, validate);

  const handleSubmit = e => {
    console.log(e);
    e.preventDefault();
    // if (validate()) {
    console.log(validate());
    setOpenPopup(false);
    addOrEdit(values, resetForm);
    // }
  };

  useEffect(() => {
    if (recordForEdit != null)
      setValues({
        ...recordForEdit
      });
  }, [setValues, recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <RadioGroup
          label="의견"
          name="opinion"
          value={values.opinion}
          onChange={handleInputChange}
          items={ContentItems}
        />
        <Input
          label="종목명"
          name="name"
          value={values.name}
          onChange={handleInputChange}
          error={errors.name}
        />

        <Input
          label="내용"
          name="contents"
          value={values.contents}
          onChange={handleInputChange}
        />
        <Select
          name="departmentId"
          label="Department"
          value={values.departmentId}
          onChange={handleInputChange}
          options={employeeService.getDepartmentCollection()}
          error={errors.departmentId}
        />
        <div>
          <Button type="submit" text="Submit" onClick={InsertForm} />
          <Button text="Reset" color="default" onClick={resetForm} />
        </div>
      </Grid>
    </Form>
  );
}
